<template>
  <div id="app">
    <img alt="mymai" style="width: 100%;" src="./assets/mm.jpg">
    <MyMai></MyMai>
  </div>
</template>

<script>
import MyMai from './components/MyMai.vue'

export default {
  name: 'app',
  components: {
    MyMai
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
